<template>
  <b-card class="mb-4 shadow-sm bg-darkblue text-white">
    <!-- Cabeçalho do pedido -->
    <b-row class="mb-3">
      <b-col cols="12" md="6">
        <h5>Pedido #{{ pedido.id }}</h5>
        <p class="mb-1"><strong>Data:</strong> {{ formatDate(pedido.data) }}</p>
        <p class="mb-0">
          <b-badge
            :variant="pedido.situacao_pedido=='Pagamento aprovado'?'success':'info'"
            style="color: #000;"
          >{{ pedido.situacao_pedido }}</b-badge>
        </p>
      </b-col>
      <b-col cols="12" md="6" class="text-md-right">
        <p class="mb-1"><strong>Frete:</strong> {{ pedido.frete }}</p>
        <p class="mb-1">
          <strong>Valor frete:</strong> R$ {{ $util.formatMoney(pedido.frete_valor) }}
        </p>
        <p class="mb-0">
          <strong>Código de rastreio:</strong> {{ pedido.codigo_rastreio }}
        </p>
        <p class="mb-0">
          <strong>Meio de pagamento:</strong>
          {{ pedido.informacoes.pagamento.meio }}
        </p>
        <a
          v-if="pedido.nota_fiscal_arquivo"
          :href="pedido.nota_fiscal_arquivo"
          target="_blank"
          class="mb-0 d-block"
          ><strong>Baixar Nota fiscal</strong></a
        >
        <a
          v-else-if="pedido.nota_fiscal"
          :href="pedido.nota_fiscal"
          target="_blank"
          class="mb-0 d-block"
          ><strong>Baixar Nota fiscal</strong></a
        >
        <a
          v-if="pedido.nota_fiscal_xml"
          :href="pedido.nota_fiscal_xml"
          target="_blank"
          class="mb-0 d-block"
          ><strong>Baixar XML da Nota Fiscal</strong></a
        >
      </b-col>
    </b-row>
    <!-- Produtos -->
    <h6 class="mb-2">Produtos</h6>
    <b-table
      :items="pedido.produtos"
      :fields="['imagem', 'nome', 'quantidade', 'total']"
      bordered
      dark
      small
      responsive
    >
      <template #cell(imagem)="data">
        <div class="text-center">

        <img style="height:45px!important;" :src="imagemProduto(data.item)" height="45" alt="Produto" @error="($event) => ($event.target.src = '/assets/loading2.gif')" />
        </div>
      </template>
      <template #cell(nome)="data">
        {{ data.item.nome }}
        <div v-if="data.item.tensao" class="small text-muted">Tensão: {{ data.item.tensao === '110V' ? '110 V' : data.item.tensao === '220V' ? '220 V' : data.item.tensao }}</div>
      </template>
      <template #cell(total)="data">
        R$ {{ $util.formatMoney(data.item.total) }}
      </template>
    </b-table>

    <!-- Total geral (produtos + frete) -->
    <div class="d-flex justify-content-end mb-3">
      <table class="table-total-geral">
        <tbody>
          <tr>
            <td class="text-right pr-3">Subtotal (produtos):</td>
            <td class="text-right">R$ {{ $util.formatMoney(totalProdutos) }}</td>
          </tr>
          <tr>
            <td class="text-right pr-3">Frete ({{ pedido.frete }}):</td>
            <td class="text-right">R$ {{ $util.formatMoney(pedido.frete_valor) }}</td>
          </tr>
          <tr class="total-geral-linha">
            <td class="text-right pr-3"><strong>Total Geral:</strong></td>
            <td class="text-right"><strong>R$ {{ $util.formatMoney(pedido.informacoes?.resumo?.totalFinal ?? totalGeral) }}</strong></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Endereço -->
    <h6 class="mt-3">Endereço de entrega</h6>
    <b-row>
      <b-col cols="12" md="6">
        <p class="mb-1">
          {{ pedido.endereco.logradouro }}, {{ pedido.endereco.numero }}
        </p>
        <p class="mb-1" v-if="pedido.endereco.complemento">
          Compl.: {{ pedido.endereco.complemento }}
        </p>
        <p class="mb-1">{{ pedido.endereco.bairro }}</p>
        <p class="mb-1">
          {{ pedido.endereco.cidade }} - {{ pedido.endereco.estado }}
        </p>
        <p class="mb-0">CEP: {{ pedido.endereco.cep }}</p>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="d-flex justify-content-end">
        <div>
          <b-btn
            v-if="podeCancelar"
            variant="outline-warning"
            class="mr-2"
            @click="$bvModal.show(`modal-cancelar-pedido-${pedido.id}`)"
          >
            <b-icon icon="x-circle"></b-icon> Cancelar pedido
          </b-btn>
          <b-btn
            v-if="podeExcluir"
            variant="outline-danger"
            class="mr-2"
            @click="$bvModal.show(`modal-excluir-pedido-${pedido.id}`)"
          >
            <b-icon icon="trash"></b-icon> Excluir pedido
          </b-btn>
          <b-btn
            variant="primary"
            style="color: #000;"
            @click="$bvModal.show(`modal-info-pedido-${pedido.id}`)"
          >
            Detalhes do Pedido
          </b-btn>
        </div>
      </b-col>
    </b-row>

    <!-- Confirmação de cancelamento -->
    <b-modal
      :id="`modal-cancelar-pedido-${pedido.id}`"
      hide-header
      hide-footer
      content-class="bg-darkblue text-white"
      centered
    >
      <h5 class="text-center mb-3">Cancelar pedido #{{ pedido.id }}?</h5>
      <p class="text-center">
        Isso cancela a cobrança pendente (PIX/boleto) no Mercado Pago - você não será cobrado por este pedido.
        Depois de cancelado, ele poderá ser excluído da sua lista.
      </p>
      <p v-if="erroCancelamento" class="text-center text-warning">{{ erroCancelamento }}</p>
      <div class="d-flex justify-content-center gap-2 mt-4">
        <b-btn
          variant="secondary"
          class="mr-2"
          @click="$bvModal.hide(`modal-cancelar-pedido-${pedido.id}`)"
        >
          Voltar
        </b-btn>
        <b-btn variant="warning" :disabled="cancelando" @click="cancelarPedido">
          {{ cancelando ? "Cancelando..." : "Sim, cancelar pedido" }}
        </b-btn>
      </div>
    </b-modal>

    <!-- Confirmação de exclusão -->
    <b-modal
      :id="`modal-excluir-pedido-${pedido.id}`"
      hide-header
      hide-footer
      content-class="bg-darkblue text-white"
      centered
    >
      <h5 class="text-center mb-3">Excluir pedido #{{ pedido.id }}?</h5>
      <p class="text-center">
        Esta ação não pode ser desfeita. Tem certeza de que deseja excluir este pedido?
      </p>
      <div class="d-flex justify-content-center gap-2 mt-4">
        <b-btn
          variant="secondary"
          class="mr-2"
          @click="$bvModal.hide(`modal-excluir-pedido-${pedido.id}`)"
        >
          Cancelar
        </b-btn>
        <b-btn variant="danger" :disabled="excluindo" @click="excluirPedido">
          {{ excluindo ? "Excluindo..." : "Sim, excluir" }}
        </b-btn>
      </div>
    </b-modal>

    <b-modal
      :id="`modal-info-pedido-${pedido.id}`"
      hide-header
      hide-footer
      content-class="bg-darkblue text-white"
      @hidden="onModalDetalhesFechado"
    >
      <button
        type="button"
        class="btn-close-pedido"
        aria-label="Fechar"
        @click="$bvModal.hide(`modal-info-pedido-${pedido.id}`)"
      >
        &times;
      </button>
      <b-row>
        <b-col>
          <h4 class="text-center">Detalhes do Pedido #{{ pedido.id }}</h4>
          <hr class="bg-white" />
          <p><strong>Status:</strong> {{ pedido.situacao_pedido }}</p>
          <p>
            <strong>Valor Total:</strong> R$
            {{ $util.formatMoney(pedido.informacoes.resumo.totalFinal) }}
          </p>

          <h5>Informações do Cliente</h5>
          <ul class="list-unstyled">
            <li>
              <strong>Nome:</strong> {{ pedido.informacoes.cliente.nome }}
            </li>
            <li>
              <strong>E-mail:</strong> {{ pedido.informacoes.cliente.email }}
            </li>
            <li><strong>CPF:</strong> {{ pedido.informacoes.cliente.cpf }}</li>
          </ul>

          <h5>Endereço de Entrega</h5>
          <ul class="list-unstyled">
            <li>
              <strong>Logradouro:</strong>
              {{ pedido.informacoes.cliente.endereco.logradouro }},
              {{ pedido.informacoes.cliente.endereco.numero }}
            </li>
            <li v-if="pedido.informacoes.cliente.endereco.complemento">
              <strong>Complemento:</strong>
              {{ pedido.informacoes.cliente.endereco.complemento }}
            </li>
            <li>
              <strong>Bairro:</strong>
              {{ pedido.informacoes.cliente.endereco.bairro }}
            </li>
            <li>
              <strong>Cidade/Estado:</strong>
              {{ pedido.informacoes.cliente.endereco.cidade }} -
              {{ pedido.informacoes.cliente.endereco.estado }}
            </li>
            <li>
              <strong>CEP:</strong>
              {{ pedido.informacoes.cliente.endereco.cep }}
            </li>
          </ul>

          <p>
            <strong>Valor do Frete:</strong> R$
            {{ $util.formatMoney(pedido.frete_valor) }} ({{ pedido.frete }})
          </p>
          <hr class="bg-white" />
          <h5 class="text-end">
            Total Geral: R$
            {{ $util.formatMoney(pedido.informacoes.resumo.totalFinal) }}
          </h5>

          <h5 class="mt-4">Informações de Pagamento</h5>
          <div class="payment-details">
            <div v-if="pedido.informacoes.pagamento.meio === 'boleto'">
              <p><strong>Meio de Pagamento:</strong> Boleto Bancário</p>
              <p>
                O seu boleto foi gerado com sucesso. Clique no botão abaixo para
                visualizá-lo ou baixá-lo.
              </p>
              <div class="d-grid gap-2">
                <b-button
                  variant="primary"
                  :href="
                    pedido.informacoes.details.transaction_details
                      .external_resource_url
                  "
                  target="_blank"
                >
                  Baixar Boleto
                </b-button>
              </div>
            </div>
            <div v-else-if="pedido.informacoes.pagamento.meio === 'pix'">
              <p><strong>Meio de Pagamento:</strong> PIX</p>
              <p>
                Aponte a câmera do seu celular para o QR Code abaixo para
                efetuar o pagamento. O pagamento será confirmado em instantes.
              </p>
              <div class="d-flex justify-content-center" v-if="displayQrCode">
                <QrcodeVue
                  :value="
                    pedido.informacoes.details.point_of_interaction
                      .transaction_data.qr_code
                  "
                  size="180"
                  level="M"
                  render-as="svg"
                />
              </div>
              <p class="mt-2 text-center">Ou copie a chave PIX:</p>
              <div class="d-grid gap-2">
                <b-input-group>
                  <b-form-input
                    class="bg-secondary text-white"
                    readonly
                    :value="
                      pedido.informacoes.details.point_of_interaction
                        .transaction_data.qr_code
                    "
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      @click="
                        copyToClipboard(
                          pedido.informacoes.details.point_of_interaction
                            .transaction_data.qr_code
                        )
                      "
                      variant="outline-secondary"
                      class="text-white"
                    >
                      Copiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
            </div>

            <div
              v-else-if="pedido.informacoes.pagamento.meio === 'transferencia'"
            >
              <p><strong>Meio de Pagamento:</strong> Transferência Bancária</p>
              <p>
                Por favor, realize a transferência para uma das contas bancárias
                listadas abaixo. Após a transferência, anexe o comprovante de
                pagamento no botão 'Anexar Comprovante'.
              </p>

              <div v-if="carregandoDadosBancarios" class="text-white-50 mb-3">
                Carregando dados bancários...
              </div>

              <div
                v-else-if="!bancosDisponiveis.length"
                class="text-warning mb-3"
              >
                Nenhuma conta bancária configurada no momento. Entre em
                <router-link to="/contato/">contato</router-link> para combinar o pagamento por transferência.
              </div>

              <div
                v-else
                v-for="(banco, idx) in bancosDisponiveis"
                :key="idx"
                class="bank-account-card mb-3"
              >
                <h6 class="mb-2">{{ banco.label }}</h6>
                <div class="bank-account-row" v-if="banco.agencia">
                  <span class="label">Agência:</span> {{ banco.agencia }}
                </div>
                <div class="bank-account-row" v-if="banco.operacao">
                  <span class="label">Operação:</span> {{ banco.operacao }}
                </div>
                <div class="bank-account-row" v-if="banco.conta">
                  <span class="label">Conta:</span> {{ banco.conta }}
                </div>
                <div class="bank-account-row" v-if="banco.titular">
                  <span class="label">Titular:</span> {{ banco.titular }}
                </div>
                <div class="bank-account-row" v-if="banco.cnpj_cpf_titular">
                  <span class="label">CNPJ:</span> {{ banco.cnpj_cpf_titular }}
                </div>
                <div class="bank-account-row" v-if="banco.chave_pix">
                  <span class="label">Chave PIX:</span> {{ banco.chave_pix }}
                </div>
              </div>

              <div class="d-grid gap-2">
                <input
                  type="file"
                  :ref="`comprovante-input-${pedido.id}`"
                  accept="image/jpeg,image/png,image/webp,application/pdf"
                  style="display: none;"
                  @change="onComprovanteSelecionado"
                />
                <b-button
                  variant="primary"
                  style="color: #000;"
                  :disabled="enviandoComprovante"
                  @click="abrirSeletorComprovante"
                >
                  <b-spinner small v-if="enviandoComprovante"></b-spinner>
                  <template v-else>
                    <b-icon icon="upload"></b-icon> Anexar Comprovante
                  </template>
                </b-button>
                <div v-if="erroComprovante" class="text-danger small mt-1">
                  {{ erroComprovante }}
                </div>
              </div>
              <hr>
              <b-row>
                <b-col>
                  <h5>Comprovantes:</h5>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div v-if="!comprovantes.length" class="text-white-50">
                    Nenhum comprovante anexado ainda.
                  </div>
                  <b-row
                    v-for="(comprovante, idx) in comprovantes"
                    :key="idx"
                    class="mb-3"
                  >
                    <b-col>
                      <b-btn @click="downloadComprovante(comprovante)">
                        Download: {{ new Date(comprovante.atualizado_em).toLocaleDateString() }}
                      </b-btn>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>

            <div v-else>
              <p>
                <strong>Meio de Pagamento:</strong> {{ pedido.meio_pagamento }}
              </p>
              <p>
                Detalhes adicionais sobre o pagamento estarão disponíveis em
                breve.
              </p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import QrcodeVue, { QrcodeCanvas, QrcodeSvg } from "qrcode.vue";
import { getPublicApiConfig } from "@/services/apiConfig.js";

export default {
  name: "Pedido",
  components: {
    QrcodeVue,
  },
  props: {
    pedido: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      images: {},
      dadosBancarios: null,
      carregandoDadosBancarios: false,
      displayQrCode: false,
      comprovantes: [],
      enviandoComprovante: false,
      erroComprovante: "",
      excluindo: false,
      cancelando: false,
      erroCancelamento: "",
    };
  },
  computed: {
    // Só mostra bancos com dados realmente preenchidos no Gerenciador
    // (Configurações > Transferência/Boleto) - alguns podem estar
    // cadastrados mas ainda vazios.
    bancosDisponiveis() {
      const bancos = this.dadosBancarios || {};
      return Object.values(bancos).filter(
        (b) => b && (b.agencia || b.conta || b.chave_pix)
      );
    },
    // Cancelar só é possível enquanto o pedido está aguardando pagamento -
    // é nesse momento que existe uma cobrança PIX/boleto pendente no
    // Mercado Pago que precisa ser desfeita.
    podeCancelar() {
      return this.pedido.situacao_pedido === "Aguardando pagamento";
    },
    // Excluir só depois de cancelado (ou já recusado) - excluir direto de
    // "Aguardando pagamento" deixaria a cobrança viva no Mercado Pago, e o
    // cliente continuaria recebendo e-mail de cobrança por um pedido que
    // já não aparece mais pra ele.
    podeExcluir() {
      return ["Cancelado", "Pagamento recusado"].includes(
        this.pedido.situacao_pedido
      );
    },
    // Soma dos produtos (sem frete) - usada tanto para o "Subtotal" quanto
    // como fallback do total geral, caso um pedido antigo não tenha o campo
    // informacoes.resumo.totalFinal salvo.
    totalProdutos() {
      return (this.pedido.produtos || []).reduce(
        (soma, p) => soma + (parseFloat(p.total) || 0),
        0
      );
    },
    totalGeral() {
      return this.totalProdutos + (parseFloat(this.pedido.frete_valor) || 0);
    },
  },
  created() {
    if (this.pedido.informacoes.pagamento.meio === "transferencia") {
      this.carregarDadosBancarios();
      this.loadFiles();
    }

    setTimeout(() => {
      this.displayQrCode = true;
    }, 2000);
  },
  methods: {
    carregarDadosBancarios() {
      this.carregandoDadosBancarios = true;
      getPublicApiConfig()
        .then((cfg) => {
          this.dadosBancarios = cfg?.transferencia_boleto || {};
        })
        .catch(() => {
          this.dadosBancarios = {};
        })
        .finally(() => {
          this.carregandoDadosBancarios = false;
        });
    },
    // Roda ao fechar o modal de detalhes (por qualquer meio: clique fora,
    // ESC, etc.). Remove o pedido_id salvo no localStorage para que este
    // modal não volte a abrir sozinho em visitas futuras à tela de Meus
    // Pedidos (ver Orders.vue).
    onModalDetalhesFechado() {
      localStorage.removeItem("pedido_id");
    },
    imagemProduto(item) {
      // As imagens do produto já vêm salvas junto do pedido (campo
      // `imagens`, o mesmo usado no carrinho) - não existe mais uma API de
      // imagens separada (legada do antigo backend Railway) para buscar.
      if (item?.imagens && item.imagens.length) {
        return this.$util.getImageBackend(item.imagens[0]) || "/assets/loading2.gif";
      }
      return "/assets/loading2.gif";
    },
    cancelarPedido() {
      this.cancelando = true;
      this.erroCancelamento = "";
      this.$api
        .httpService()
        .post(window.location.origin + "/api/order_cancel.php", {
          id: this.pedido.id,
        })
        .then(() => {
          this.cancelando = false;
          this.$bvModal.hide(`modal-cancelar-pedido-${this.pedido.id}`);
          // Atualiza localmente para refletir o novo status sem precisar
          // recarregar a lista inteira - libera a opção "Excluir pedido"
          // imediatamente.
          this.pedido.situacao_pedido = "Cancelado";
          this.$emit("cancelado", this.pedido.id);
        })
        .catch((err) => {
          this.cancelando = false;
          console.error(err);
          this.erroCancelamento =
            err?.response?.data?.error ||
            "Não foi possível cancelar o pedido. Tente novamente.";
        });
    },
    excluirPedido() {
      this.excluindo = true;
      this.$api
        .httpService()
        .delete(window.location.origin + "/api/order_delete.php", {
          data: { id: this.pedido.id },
        })
        .then(() => {
          this.excluindo = false;
          this.$bvModal.hide(`modal-excluir-pedido-${this.pedido.id}`);
          this.$emit("excluido", this.pedido.id);
        })
        .catch((err) => {
          this.excluindo = false;
          console.error(err);
          alert(
            (err?.response?.data?.error) ||
              "Não foi possível excluir o pedido. Tente novamente."
          );
        });
    },
    downloadComprovante(comprovante) {
      this.$api
        .httpService()
        .get(window.location.origin + "/api/comprovante_download.php", {
          params: { id: comprovante.id },
        })
        .then((res) => {
          this.$util.downloadAnyBase64File(
            res.data.base64,
            res.data.nome_original?.replace(/\.[^.]+$/, "") || "comprovante"
          );
        })
        .catch((err) => {
          console.error(err);
          alert("Não foi possível baixar o comprovante. Tente novamente.");
        });
    },
    loadFiles() {
      this.comprovantes = [];
      this.$api
        .httpService()
        .get(window.location.origin + "/api/comprovante_list.php", {
          params: { pedido: this.pedido.id },
        })
        .then((res) => {
          this.comprovantes = res.data;
        })
        .catch((err) => console.error("Erro ao carregar comprovantes:", err));
    },
    // Clica programaticamente no input de arquivo oculto, abrindo direto o
    // seletor de arquivos do sistema operacional ao clicar no botão
    // "Anexar Comprovante".
    abrirSeletorComprovante() {
      const input = this.$refs[`comprovante-input-${this.pedido.id}`];
      if (input) input.click();
    },
    // Assim que o cliente escolhe o arquivo, o upload já é enviado
    // automaticamente para o servidor (sem precisar de um segundo clique
    // num botão "enviar" separado).
    onComprovanteSelecionado(evento) {
      const arquivo = evento.target.files && evento.target.files[0];
      // Limpa o valor do input para permitir reenviar o mesmo arquivo (ex.:
      // depois de um erro) sem precisar escolher outro nome de arquivo.
      evento.target.value = "";
      if (!arquivo) return;

      this.erroComprovante = "";
      this.enviandoComprovante = true;

      const formData = new FormData();
      formData.append("comprovante", arquivo);
      formData.append("pedido_id", this.pedido.id);

      this.$api
        .httpService()
        .post(window.location.origin + "/api/comprovante_upload.php", formData, {
          headers: { "Content-Type": null },
        })
        .then(() => {
          this.loadFiles();
        })
        .catch((err) => {
          console.error(err);
          this.erroComprovante =
            err?.response?.data?.error ||
            "Não foi possível enviar o comprovante. Tente novamente.";
        })
        .finally(() => {
          this.enviandoComprovante = false;
        });
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("pt-BR");
    },
    async copyToClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        alert("Código PIX copiado para a área de transferência!");
      } catch (err) {
        console.error("Falha ao copiar:", err);
      }
    },
  },
};
</script>

<style scoped>
h5 {
  font-weight: 600;
}
.btn-close-pedido {
  position: absolute;
  top: 12px;
  right: 16px;
  z-index: 10;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 1.75rem;
  line-height: 1;
  opacity: 0.8;
  cursor: pointer;
  padding: 0 4px;
}
.btn-close-pedido:hover {
  opacity: 1;
}
.bank-account-card {
  background: #202a3b;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  padding: 14px 16px;
}
.bank-account-card h6 {
  color: #e77d36;
  font-weight: 700;
}
.bank-account-card .bank-account-row {
  font-size: 0.9rem;
  margin-bottom: 4px;
}
.bank-account-card .bank-account-row .label {
  font-weight: 600;
  color: #ffffff;
  margin-right: 4px;
}
.table-total-geral {
  min-width: 260px;
}
.table-total-geral td {
  padding: 3px 4px;
  font-size: 0.92rem;
}
.table-total-geral .total-geral-linha td {
  border-top: 1px solid rgba(255, 255, 255, 0.25);
  padding-top: 8px;
  font-size: 1.05rem;
}
</style>
